/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordResetRequest
 */
export interface PasswordResetRequest {
    /**
     * 
     */
    email: string;
}

/**
 * Check if a given object implements the PasswordResetRequest interface.
 */
export function instanceOfPasswordResetRequest(value: object): value is PasswordResetRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function PasswordResetRequestFromJSON(json: any): PasswordResetRequest {
    return PasswordResetRequestFromJSONTyped(json, false);
}

export function PasswordResetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function PasswordResetRequestToJSON(json: any): PasswordResetRequest {
    return PasswordResetRequestToJSONTyped(json, false);
}

export function PasswordResetRequestToJSONTyped(value?: PasswordResetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

